import { FilterContainer } from 'components';
import { Button, Grid, MenuItem, TextField } from "@material-ui/core"
import { ticketsContext } from '../../TicketsContext';
import { Search } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { applicationContext, appUserContext } from 'helpers/services';
import { Autocomplete } from '@material-ui/lab';
import { SCAutocomplete } from 'components';
import { UserType, TicketFilters, ReferenceData } from 'helpers/enums';
import { DatePicker } from '@material-ui/pickers';
import FiltersDialog from './FiltersDialog';


let Filters = () => {
    let { doSearch, updateSearch, search, queue, filterLabel, filtersByQueue } = useContext(ticketsContext);
    let {
        userFilters,
        referenceData,
        ticketStatuses,
        ticketTypes,
        ticketStatusesNames,
        customerServiceUsers,
        assignableUsers,
        userGroups,
        searchReporters,
        searchCustomers,

    } = useContext(applicationContext);

    let { currentUser } = useContext(appUserContext);

    let [csSearchText, setCSsearchText] = useState('');
    let [assignee, setAssignee] = useState('');

    return (
        <FilterContainer onSubmit={() => doSearch(search)}>
            {userFilters.indexOf(TicketFilters.Ticket) !== -1 &&
                <Grid item>
                    <TextField
                        label={filterLabel[TicketFilters.Ticket]}
                        value={search.fullText}
                        onChange={(e) => {
                            updateSearch({
                                ...search,
                                fullText: e.target.value
                            })
                        }}
                    />
                </Grid>
            }

            {userFilters.indexOf(TicketFilters.Status) !== -1 &&
                <Grid item>
                    {currentUser?.typology === UserType.VitecUser &&
                        <TextField
                            label={filterLabel[TicketFilters.Status]}
                            SelectProps={{ multiple: true }}
                            select
                            value={search.status}
                            onChange={(e) => {
                                updateSearch({
                                    ...search,
                                    status: e.target.value as any || []
                                })
                            }}
                        >
                            {ticketStatuses.map(status => <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>)}
                        </TextField>
                    }
                    {currentUser?.typology === UserType.Customer &&
                        <TextField
                            label={filterLabel[TicketFilters.Status]}
                            SelectProps={{ multiple: true }}
                            select
                            value={search.customerStatus}
                            onChange={(e) => {
                                updateSearch({
                                    ...search,
                                    customerStatus: e.target.value as any || []
                                })
                            }}
                        >
                            {ticketStatusesNames.map(status => <MenuItem key={status} value={status}>{status}</MenuItem>)}
                        </TextField>
                    }
                </Grid>
            }

            {userFilters.indexOf(TicketFilters.Type) !== -1 &&
                <Grid item>
                    <TextField
                        label={filterLabel[TicketFilters.Type]}
                        select
                        value={search.type}
                        onChange={(e) => updateSearch({
                            ...search,
                            type: e.target.value
                        })}
                    >
                        <MenuItem value=''>Any</MenuItem>
                        {ticketTypes.map(type =>
                            <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                        )}
                    </TextField>
                </Grid>
            }


            {currentUser?.typology === UserType.VitecUser &&
                <>
                    {userFilters.indexOf(TicketFilters.LastUpdateFrom) !== -1 &&
                        <Grid item>
                            <DatePicker
                                label={filterLabel[TicketFilters.LastUpdateFrom]}
                                format="LL"
                                value={search.lastUpdatedOnFrom}
                                onChange={(newValue) => updateSearch({
                                    ...search,
                                    lastUpdatedOnFrom: newValue?.toDate() || null
                                })}
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.Supplier) !== -1 &&
                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.Supplier]}
                                select
                                value={search.supplier}
                                onChange={(e) => updateSearch({
                                    ...search,
                                    supplier: e.target.value
                                })}
                            >
                                <MenuItem value=''>Any</MenuItem>
                                {referenceData
                                    .getByKey(ReferenceData.Supplier)?.values
                                    .map(x => <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)
                                }
                            </TextField>
                        </Grid>
                    }

                    {filtersByQueue.getValueByKey(queue).indexOf(TicketFilters.Group) !== -1
                        && userFilters.indexOf(TicketFilters.Group) !== -1 &&

                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.Group]}
                                select
                                value={search.userGroup}
                                onChange={(e) => updateSearch({
                                    ...search,
                                    userGroup: e.target.value
                                })}
                            >
                                <MenuItem value=''>Any</MenuItem>
                                {userGroups.map(userGroup =>
                                    <MenuItem key={userGroup.key} value={userGroup.key}>{userGroup.value}</MenuItem>
                                )}
                            </TextField>
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.Reporter) !== -1 &&
                        <Grid item>
                            <SCAutocomplete
                                inputLabel={filterLabel[TicketFilters.Reporter]}
                                value={{
                                    value: search.reporter,
                                    label: search.reporterName
                                }}
                                doSearch={async (value: string, etag: number) => await searchReporters(value, etag)}
                                onChange={(value: any) => {
                                    updateSearch({
                                        ...search,
                                        reporter: value?.value || '',
                                        reporterName: value?.label || '',
                                    })
                                }}
                            />
                        </Grid>
                    }

                    {filtersByQueue.getValueByKey(queue).indexOf(TicketFilters.Assignee) !== -1
                        && userFilters.indexOf(TicketFilters.Assignee) !== -1 &&

                        <Grid item>
                            <Autocomplete
                                value={search.assignee}
                                onChange={(event, newValue) =>
                                    updateSearch({
                                        ...search,
                                        assignee: newValue || ''
                                    })
                                }
                                inputValue={assignee}
                                onInputChange={(event, newInputValue) => setAssignee(newInputValue)}
                                getOptionLabel={(option) => {
                                    return option === 'null'
                                        ? "Unassigned"
                                        : assignableUsers.getValueByKey(option, 'email', 'name');
                                }}
                                options={[
                                    'null',
                                    ...assignableUsers.map(x => x.email)
                                ]}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        label={filterLabel[TicketFilters.Assignee]}
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.CSAssignee) !== -1 &&
                        <Grid item>
                            <Autocomplete
                                value={search.csAssignee}
                                onChange={(event, newValue) =>
                                    updateSearch({
                                        ...search,
                                        csAssignee: newValue || ''
                                    })
                                }
                                inputValue={csSearchText}
                                onInputChange={(event, newInputValue) => setCSsearchText(newInputValue)}
                                getOptionLabel={(option) => {
                                    return option === 'null'
                                        ? "Unassigned"
                                        : customerServiceUsers.getValueByKey(option);
                                }}
                                options={[
                                    'null',
                                    ...customerServiceUsers.map(x => x.key)
                                ]}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        label={filterLabel[TicketFilters.CSAssignee]}
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.ServiceOrder) !== -1 &&
                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.ServiceOrder]}
                                value={search.serviceOrder}
                                onChange={(e) => {
                                    updateSearch({
                                        ...search,
                                        serviceOrder: e.target.value
                                    })
                                }}
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.CustomerOrder) !== -1 &&
                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.CustomerOrder]}
                                value={search.customerOrder}
                                onChange={(e) => {
                                    updateSearch({
                                        ...search,
                                        customerOrder: e.target.value
                                    })
                                }}
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.ProductSKU) !== -1 &&
                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.ProductSKU]}
                                value={search.productSKU}
                                onChange={(e) => {
                                    updateSearch({
                                        ...search,
                                        productSKU: e.target.value
                                    })
                                }}
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.Customer) !== -1 &&
                        <Grid item xs={2}>
                            <SCAutocomplete
                                inputLabel={filterLabel[TicketFilters.Customer]}
                                value={{
                                    value: search.customerM3Id,
                                    label: search.customerName
                                }}
                                doSearch={async (value: string, etag: number) => await searchCustomers(value, etag)}
                                onChange={(value: any) => {
                                    updateSearch({
                                        ...search,
                                        customerM3Id: value?.value || '',
                                        customerName: value?.label || '',
                                    })
                                }}
                            />
                        </Grid>
                    }

                    {userFilters.indexOf(TicketFilters.SerialNumber) !== -1 &&
                        <Grid item>
                            <TextField
                                label={filterLabel[TicketFilters.SerialNumber]}
                                value={search.serialNumber}
                                onChange={(e) => {
                                    updateSearch({
                                        ...search,
                                        serialNumber: e.target.value
                                    })
                                }}
                            />
                        </Grid>
                    }
                </>
            }

            <Grid item>
                <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                >
                    <Search />
                </Button>
            </Grid>
            {currentUser?.typology === UserType.VitecUser &&
                <Grid item>
                    <FiltersDialog queue={queue} />
                </Grid>
            }
        </FilterContainer>
    )
}

export default Filters;